import constants from 'constants/index'

const idToLabel = (id) => {
  return constants.fragilities.FRAGILITIES_LABELS[id]
}

export default idToLabel
